module.exports = __webpack_public_path__ + "src/img/cookies/grid-of-phones.2400b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/cookies/grid-of-phones.jpg
// module id = 105
// module chunks = 0